import { Container as MuiContainer } from '@mui/material';
import React from 'react';
import { RenderChildren } from '@/node-editor/components';
import { getSpacerValue, rgbToCssColor } from '@/lib/utils/format';
import { INode, INodeProps } from '@/types/node';
import { IContent } from './contract';
import { useNodeProps } from '@/node-editor/hooks';
import { useTheme } from '@mui/material/styles';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

export const Render = ({
  node: {
    id,
    override,
    content: {
      backgroundColor,
      textColor,
      alignment,
      containerWidth,
      minHeight = 0,
      verticalSpacing,
    },
  },
  children,
}: IProps) => {
  const theme = useTheme();

  const containerSx = {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    flexWrap: 'wrap',
    justifyContent: alignment.vertical,
    alignItems: alignment.horizontal,
    minHeight: minHeight === 0 ? 'auto' : `${minHeight}px`,
    maxWidth:
      (containerWidth as string) === 'full' || !containerWidth
        ? `none !important`
        : `${
            theme.breakpoints.values[
              containerWidth as keyof typeof theme.breakpoints.values
            ]
          }px !important`,
    ...(backgroundColor && {
      backgroundColor: rgbToCssColor(backgroundColor as any),
    }),
    ...(textColor && { color: rgbToCssColor(textColor as any) }),
    paddingTop: theme.spacing(getSpacerValue(verticalSpacing.top)),
    paddingBottom: theme.spacing(getSpacerValue(verticalSpacing.bottom)),
    ...override.root,
  };

  return (
    <MuiContainer
      disableGutters={!containerWidth}
      sx={containerSx}
      {...useNodeProps(id)}
    >
      <RenderChildren>{children}</RenderChildren>
    </MuiContainer>
  );
};
